/**
 * Identity function, returns its argument unchanged
 */
export function id(i) {
    return i;
}
/**
 * Identity assertion, always passes
 */
export function idAssert(i) {
    //
}
/**
 * Magic cast, returns its argument unchanged, but with a different type
 *
 * Equivalent to mem::transmute in rust, and has the same caveats
 */
export function magicCast(val) {
    return val;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLFVBQVUsRUFBRSxDQUFJLENBQUk7SUFDekIsT0FBTyxDQUFDLENBQUE7QUFDVCxDQUFDO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsUUFBUSxDQUFJLENBQU07SUFDakMsRUFBRTtBQUNILENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxVQUFVLFNBQVMsQ0FBTyxHQUFNO0lBQ3JDLE9BQU8sR0FBbUIsQ0FBQTtBQUMzQixDQUFDIn0=